import { z } from 'zod'

export const billingAdminDashboardReadResponseSchema = z.object({}).passthrough()
export type BillingAdminDashboardReadResponse = z.infer<typeof billingAdminDashboardReadResponseSchema>
